import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TurkmenistanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16090'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16090)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V0H0V14Z'
					fill='#30C375'
				/>
				<rect
					x='2.85742'
					width='2.85714'
					height='14'
					fill='#DE414F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28599 2.80002C5.07497 2.80002 5.71456 2.38215 5.71456 1.86668C5.71456 1.35122 5.07497 0.93335 4.28599 0.93335C3.49702 0.93335 2.85742 1.35122 2.85742 1.86668C2.85742 2.38215 3.49702 2.80002 4.28599 2.80002Z'
					fill='white'
				/>
				<mask
					id='mask1_2332_16090'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='0'
					width='4'
					height='3'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28599 2.80002C5.07497 2.80002 5.71456 2.38215 5.71456 1.86668C5.71456 1.35122 5.07497 0.93335 4.28599 0.93335C3.49702 0.93335 2.85742 1.35122 2.85742 1.86668C2.85742 2.38215 3.49702 2.80002 4.28599 2.80002Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_16090)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28674 2.33336C4.54973 2.33336 4.76293 2.12442 4.76293 1.86669C4.76293 1.60896 4.54973 1.40002 4.28674 1.40002C4.02374 1.40002 3.81055 1.60896 3.81055 1.86669C3.81055 2.12442 4.02374 2.33336 4.28674 2.33336Z'
						fill='#DD404F'
					/>
					<rect
						x='2.85742'
						y='0.93335'
						width='1.42857'
						height='0.933333'
						fill='#FBAF29'
					/>
					<rect
						x='4.28516'
						y='1.8667'
						width='1.42857'
						height='0.933333'
						fill='#FBAF29'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28599 13.0666C5.07497 13.0666 5.71456 12.6488 5.71456 12.1333C5.71456 11.6178 5.07497 11.2 4.28599 11.2C3.49702 11.2 2.85742 11.6178 2.85742 12.1333C2.85742 12.6488 3.49702 13.0666 4.28599 13.0666Z'
					fill='white'
				/>
				<mask
					id='mask2_2332_16090'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='11'
					width='4'
					height='3'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28599 13.0666C5.07497 13.0666 5.71456 12.6488 5.71456 12.1333C5.71456 11.6178 5.07497 11.2 4.28599 11.2C3.49702 11.2 2.85742 11.6178 2.85742 12.1333C2.85742 12.6488 3.49702 13.0666 4.28599 13.0666Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask2_2332_16090)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28674 12.6C4.54973 12.6 4.76293 12.391 4.76293 12.1333C4.76293 11.8756 4.54973 11.6666 4.28674 11.6666C4.02374 11.6666 3.81055 11.8756 3.81055 12.1333C3.81055 12.391 4.02374 12.6 4.28674 12.6Z'
						fill='#DD404F'
					/>
					<rect
						x='2.85742'
						y='11.2'
						width='1.42857'
						height='0.933333'
						fill='#FBAF29'
					/>
					<rect
						x='4.28516'
						y='12.1333'
						width='1.42857'
						height='0.933333'
						fill='#FBAF29'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28599 8.39999C5.07497 8.39999 5.71456 7.98212 5.71456 7.46666C5.71456 6.95119 5.07497 6.53333 4.28599 6.53333C3.49702 6.53333 2.85742 6.95119 2.85742 7.46666C2.85742 7.98212 3.49702 8.39999 4.28599 8.39999Z'
					fill='#28AE67'
				/>
				<mask
					id='mask3_2332_16090'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='6'
					width='4'
					height='3'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28599 8.39999C5.07497 8.39999 5.71456 7.98212 5.71456 7.46666C5.71456 6.95119 5.07497 6.53333 4.28599 6.53333C3.49702 6.53333 2.85742 6.95119 2.85742 7.46666C2.85742 7.98212 3.49702 8.39999 4.28599 8.39999Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask3_2332_16090)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28637 7.93333C4.81235 7.93333 5.23875 7.7244 5.23875 7.46667C5.23875 7.20893 4.81235 7 4.28637 7C3.76038 7 3.33398 7.20893 3.33398 7.46667C3.33398 7.7244 3.76038 7.93333 4.28637 7.93333Z'
						fill='#DD404F'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28599 10.2667C5.07497 10.2667 5.71456 10.0578 5.71456 9.80004C5.71456 9.54231 5.07497 9.33337 4.28599 9.33337C3.49702 9.33337 2.85742 9.54231 2.85742 9.80004C2.85742 10.0578 3.49702 10.2667 4.28599 10.2667Z'
					fill='#28AE67'
				/>
				<mask
					id='mask4_2332_16090'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='9'
					width='4'
					height='2'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28599 10.2667C5.07497 10.2667 5.71456 10.0578 5.71456 9.80004C5.71456 9.54231 5.07497 9.33337 4.28599 9.33337C3.49702 9.33337 2.85742 9.54231 2.85742 9.80004C2.85742 10.0578 3.49702 10.2667 4.28599 10.2667Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask4_2332_16090)'></g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28599 5.59994C5.07497 5.59994 5.71456 5.18208 5.71456 4.66661C5.71456 4.15114 5.07497 3.73328 4.28599 3.73328C3.49702 3.73328 2.85742 4.15114 2.85742 4.66661C2.85742 5.18208 3.49702 5.59994 4.28599 5.59994Z'
					fill='#FBAF29'
				/>
				<mask
					id='mask5_2332_16090'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='3'
					width='4'
					height='3'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28599 5.59994C5.07497 5.59994 5.71456 5.18208 5.71456 4.66661C5.71456 4.15114 5.07497 3.73328 4.28599 3.73328C3.49702 3.73328 2.85742 4.15114 2.85742 4.66661C2.85742 5.18208 3.49702 5.59994 4.28599 5.59994Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask5_2332_16090)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28674 5.13328C4.54973 5.13328 4.76293 4.92435 4.76293 4.66662C4.76293 4.40888 4.54973 4.19995 4.28674 4.19995C4.02374 4.19995 3.81055 4.40888 3.81055 4.66662C3.81055 4.92435 4.02374 5.13328 4.28674 5.13328Z'
						fill='#DD404F'
					/>
					<rect
						x='2.85742'
						y='3.73328'
						width='0.952381'
						height='1.86667'
						fill='#28AE67'
					/>
					<rect
						x='4.76172'
						y='3.73328'
						width='0.952381'
						height='1.86667'
						fill='#28AE67'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.5877 2.96674C10.4187 3.16418 10.4449 3.45853 10.6464 3.6242C10.8479 3.78987 11.1482 3.76411 11.3173 3.56668C11.4863 3.36924 11.46 3.07489 11.2586 2.90922C11.0571 2.74356 10.7568 2.76931 10.5877 2.96674ZM9.35381 4.77589C9.15235 4.61022 8.85199 4.63597 8.68294 4.83341C8.51389 5.03084 8.54017 5.3252 8.74163 5.49086C8.9431 5.65653 9.24346 5.63078 9.41251 5.43334C9.58155 5.23591 9.55528 4.94156 9.35381 4.77589ZM8.40143 3.84256C8.19997 3.67689 7.89961 3.70264 7.73056 3.90008C7.56151 4.09751 7.58779 4.39186 7.78925 4.55753C7.99072 4.7232 8.29108 4.69745 8.46013 4.50001C8.62917 4.30258 8.6029 4.00822 8.40143 3.84256ZM10.3062 1.97589C10.1047 1.81022 9.80437 1.83597 9.63532 2.03341C9.46627 2.23084 9.49255 2.5252 9.69401 2.69086C9.89548 2.85653 10.1958 2.83078 10.3649 2.63334C10.5339 2.43591 10.5077 2.14156 10.3062 1.97589ZM9.83 3.37589C9.62854 3.21022 9.32818 3.23597 9.15913 3.43341C8.99008 3.63084 9.01636 3.9252 9.21782 4.09086C9.41929 4.25653 9.71965 4.23078 9.8887 4.03334C10.0577 3.83591 10.0315 3.54156 9.83 3.37589Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.4837 6.61539C11.3493 7.72703 9.51023 7.72703 8.37591 6.61539C8.266 6.50768 8.16674 6.39348 8.07812 6.27405C9.21393 7.08342 10.8131 6.98614 11.8376 5.98222C12.862 4.9783 12.9612 3.41106 12.1353 2.29797C12.2572 2.38481 12.3737 2.48209 12.4837 2.5898C13.618 3.70144 13.618 5.50376 12.4837 6.61539Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TurkmenistanFlagIcon;
